/* bv-card-gallery.js — swipeable product-card galleries, transform-based with axis lock.
   Gesture model: the first ~8px of a touch decide the axis once. Horizontal → the track
   follows the finger and the page does not scroll (touch-action: pan-y + preventDefault);
   vertical → the page scrolls and the track ignores the gesture entirely.
   Slide 2 is the product video: plays muted/looped only while active and on screen;
   at most one card video plays at a time. Peek affordance once per card, one card at a time.
   Fires dataLayer: bv_card_video_play (first play), bv_card_swipe (first swipe). */
(function () {
  'use strict';
  if (window.__bvCardGallery) return;
  window.__bvCardGallery = true;

  var AXIS_PX = 8, SWIPE_PX = 40, PEEK_GAP_MS = 2200;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastPeekAt = 0, playing = null;
  var dl = function (o) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(o); };

  function state(anchor) {
    if (!anchor.__bv) anchor.__bv = { idx: 0, count: anchor.querySelectorAll('.bv-card__slide').length };
    return anchor.__bv;
  }
  function track(anchor) { return anchor.querySelector('[data-bv-track]'); }
  /* Extra slides are rendered without src/srcset (data-bv-src / data-bv-srcset) so a collection page
     does not download 3 hidden photos per card. wake(anchor, n): give the first n hidden slides their image. */
  function wake(anchor, n) {
    var imgs = anchor.querySelectorAll('img[data-bv-src]');
    for (var i = 0; i < imgs.length && (n === undefined || i < n); i++) {
      var im = imgs[i];
      if (im.dataset.bvSrcset) im.setAttribute('srcset', im.dataset.bvSrcset);
      im.setAttribute('src', im.dataset.bvSrc);
      /* Speed delta 1: a woken slide is one we want NOW (card on screen + idle, or a swipe/hover). It sits off-screen
         horizontally inside an overflow:hidden track, so loading="lazy" would hold it back until mid-swipe. */
      im.loading = 'eager';
      im.removeAttribute('data-bv-src'); im.removeAttribute('data-bv-srcset');
    }
  }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
  function trackWidth(anchor) { var tr = track(anchor); return (tr && tr.clientWidth) || anchor.clientWidth || 1; }
  function setX(anchor, px, pct) {
    var x = pct !== undefined ? (pct / 100) * trackWidth(anchor) : px;
    track(anchor).style.transform = 'translate3d(' + Math.round(x) + 'px,0,0)';
  }
  var DEBUG = /[?&]bvdebug=1/.test(location.search);
  function dbg(anchor, msg) {
    if (!DEBUG) return;
    var el = anchor.querySelector('.bv-card__debug');
    if (!el) { el = document.createElement('div'); el.className = 'bv-card__debug'; anchor.appendChild(el); }
    el.textContent = msg;
  }
  function stopVideo(v) { if (!v) return; v.__bvAllowed = false; v.classList.remove('is-playing'); try { v.pause(); } catch (e) {} if (playing === v) playing = null; }
  function playVideo(anchor, v) {
    if (!v || playing === v) return;
    if (playing) stopVideo(playing);
    v.muted = true; playing = v;
    if (!v.src) { var srcEl = v.querySelector('source'); if (srcEl) v.src = srcEl.src; }
    if (v.readyState === 0) { try { v.load(); } catch (e) {} }
    v.__bvAllowed = true;
    var p = v.play();
    dbg(anchor, 'play() called  rs=' + v.readyState + '  src=' + (v.currentSrc || v.src || '').slice(-40));
    if (p && p.then) p.then(function () {
      v.classList.add('is-playing');
      dbg(anchor, 'PLAYING  rs=' + v.readyState + '  ' + v.videoWidth + 'x' + v.videoHeight);
      if (!anchor.dataset.bvVideoTracked) { anchor.dataset.bvVideoTracked = '1'; dl({ event: 'bv_card_video_play', bv_product: anchor.dataset.bvProduct || '' }); }
    }).catch(function (err) {
      if (playing === v) playing = null;
      if (window.console) console.warn('[bv-card-gallery] video play blocked:', err && err.name, err && err.message);
      dbg(anchor, 'BLOCKED: ' + (err && err.name) + '\n' + (err && err.message || '').slice(0, 80));
    });
  }

  function goTo(anchor, idx, fromUser) {
    var s = state(anchor);
    if (idx > 0) wake(anchor);
    idx = Math.max(0, Math.min(s.count - 1, idx));
    if (fromUser && idx !== s.idx && !anchor.dataset.bvSwiped) { anchor.dataset.bvSwiped = '1'; dl({ event: 'bv_card_swipe', bv_product: anchor.dataset.bvProduct || '' }); }
    s.idx = idx;
    setX(anchor, 0, -idx * 100);
    syncVideo(anchor);
  }
  function syncVideo(anchor) {
    var s = state(anchor);
    var slide = anchor.querySelectorAll('.bv-card__slide')[s.idx];
    var v = slide && slide.querySelector('video');
    var other = anchor.querySelector('video');
    if (v && anchor.dataset.bvInView === '1') playVideo(anchor, v); else stopVideo(other);
  }

  function peek(anchor, force) {
    if (reduced || state(anchor).idx !== 0 || state(anchor).count < 2) return;
    if (!force && anchor.dataset.bvPeeked) return;
    var now = Date.now(); if (!force && now - lastPeekAt < PEEK_GAP_MS) return;
    lastPeekAt = now; anchor.dataset.bvPeeked = '1'; wake(anchor, 1);
    var tr = track(anchor); tr.classList.add('is-peeking');
    setX(anchor, 0, -18);
    /* Speed delta 1: if the shopper swiped during the peek, leave the slide they chose alone (used to snap back to 0). */
    setTimeout(function () { if (state(anchor).idx === 0 && !tr.classList.contains('is-dragging')) setX(anchor, 0, 0); }, 700);
    setTimeout(function () { tr.classList.remove('is-peeking'); }, 1300);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var a = entry.target;
      a.dataset.bvInView = entry.isIntersecting && entry.intersectionRatio >= 0.5 ? '1' : '0';
      if (a.dataset.bvInView === '1') {
        if (!a.__bvWoke) { a.__bvWoke = true; idle(function () { wake(a, 1); }); }
        if (a.dataset.bvHasVideo) setTimeout(function () { if (a.dataset.bvInView === '1') peek(a); }, 600);
        syncVideo(a);
      } else stopVideo(a.querySelector('video'));
    });
  }, { threshold: [0, 0.5] });

  function bind(anchor) {
    if (anchor.dataset.bvGalleryBound) return;
    anchor.dataset.bvGalleryBound = '1';
    var tr = track(anchor); if (!tr) return;
    var s = state(anchor), width = function () { return tr.clientWidth || 1; };
    var g = null; /* gesture: {x0,y0,axis,dx} */

    function onStart(x, y) { g = { x0: x, y0: y, axis: null, dx: 0 }; }
    function onMove(x, y, e) {
      if (!g) return;
      var dx = x - g.x0, dy = y - g.y0;
      if (!g.axis) {
        if (Math.abs(dx) < AXIS_PX && Math.abs(dy) < AXIS_PX) return;
        g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (g.axis === 'x') tr.classList.add('is-dragging');
      }
      if (g.axis !== 'x') return;              /* vertical: let the page scroll */
      if (e && e.cancelable) e.preventDefault();
      g.dx = dx;
      /* resistance at the ends */
      var atEdge = (s.idx === 0 && dx > 0) || (s.idx === s.count - 1 && dx < 0);
      var eff = atEdge ? dx * 0.35 : dx;
      tr.style.transform = 'translate3d(' + Math.round(-s.idx * trackWidth(anchor) + eff) + 'px,0,0)';
    }
    function onEnd() {
      if (!g) return;
      var moved = g.axis === 'x';
      tr.classList.remove('is-dragging');
      if (moved) {
        var dx = g.dx;
        if (dx < -SWIPE_PX) goTo(anchor, s.idx + 1, true);
        else if (dx > SWIPE_PX) goTo(anchor, s.idx - 1, true);
        else goTo(anchor, s.idx);
        anchor.__bvSuppressClick = true;
        setTimeout(function () { anchor.__bvSuppressClick = false; }, 350);
      }
      g = null;
    }

    tr.addEventListener('touchstart', function () { wake(anchor); }, { passive: true, once: true });
    tr.addEventListener('touchstart', function (e) { onStart(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    tr.addEventListener('touchmove', function (e) { onMove(e.touches[0].clientX, e.touches[0].clientY, e); }, { passive: false });
    tr.addEventListener('touchend', onEnd); tr.addEventListener('touchcancel', onEnd);

    tr.addEventListener('mousedown', function (e) { if (e.button !== 0) return; onStart(e.clientX, e.clientY); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (g) onMove(e.clientX, e.clientY, e); });
    window.addEventListener('mouseup', function () { if (g) onEnd(); });

    anchor.addEventListener('click', function (e) { if (anchor.__bvSuppressClick) { e.preventDefault(); e.stopPropagation(); } }, true);

    var vid = anchor.querySelector('video');
    if (vid) vid.addEventListener('play', function () { if (!vid.__bvAllowed) { try { vid.pause(); } catch (e) {} } });
    /* If something else (e.g. the theme's pauseAllMedia) pauses an allowed, in-view video, resume it. */
    if (vid) vid.addEventListener('pause', function () {
      vid.classList.remove('is-playing');
      if (vid.__bvAllowed && anchor.dataset.bvInView === '1' && playing === vid && !vid.__bvResuming) {
        vid.__bvResuming = true;
        setTimeout(function () {
          vid.__bvResuming = false;
          if (vid.__bvAllowed && vid.paused) { var r = vid.play(); if (r && r.catch) r.catch(function () {}); }
        }, 120);
      }
    });
    if (vid) vid.addEventListener('playing', function () { if (vid.__bvAllowed) vid.classList.add('is-playing'); });
    if (vid) vid.addEventListener('error', function () {
      var e = vid.error; dbg(anchor, 'MEDIA ERROR code=' + (e && e.code) + ' ' + (e && e.message || ''));
      if (window.console) console.warn('[bv-card-gallery] media error', e);
    });

    /* Desktop (hover-capable, >=750px): no swipe/dots — hover reveals slide 2 and plays the video */
    if (window.matchMedia('(hover: hover) and (min-width: 750px)').matches && s.count > 1) {
      anchor.addEventListener('mouseenter', function () { anchor.dataset.bvInView = '1'; wake(anchor); goTo(anchor, 1); });
      anchor.addEventListener('mouseleave', function () { goTo(anchor, 0); });
      anchor.dataset.bvPeeked = '1'; /* no peek on desktop */
    }

    goTo(anchor, 0);
    io.observe(anchor);
  }

  /* Public hook: other components (e.g. the "Just seen" collection pin) can ask a card to show its swipe hint. */
  window.bvCardPeek = function (anchor) { if (!anchor) return; bind(anchor); peek(anchor, true); };

  function init() { document.querySelectorAll('[data-bv-gallery]').forEach(bind); }
  var rsz;
  window.addEventListener('resize', function () {
    clearTimeout(rsz);
    rsz = setTimeout(function () {
      document.querySelectorAll('[data-bv-gallery][data-bv-gallery-bound]').forEach(function (a) { goTo(a, state(a).idx); });
    }, 120);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function () { init(); }).observe(document.body, { childList: true, subtree: true });
})();
